import { render } from "./Science.vue?vue&type=template&id=6e3d4d98&ts=true"
import script from "./Science.vue?vue&type=script&lang=ts"
export * from "./Science.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__